module.exports = "/_next/static/images/Sources-a75d475a1d468551f69ea5b01558eb83.webp";